"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerAuthLogListCtl = /** @class */ (function (_super) {
    __extends(PlayerAuthLogListCtl, _super);
    function PlayerAuthLogListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_ip_address = UIUtils_1.UIUtils.IProp2Str(function (o) { o.ip_address; });
        _this.dk_fingerprint = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fingerprint; });
        _this.dk_useragent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.useragent; });
        _this.dk_auth_kind = UIUtils_1.UIUtils.IProp2Str(function (o) { o.auth_kind; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerAuthLogListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerAuthLogListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerAuthLogListCtl.prototype.LoadAllData = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListUsrPlayerAuthLogsByUsrPlayerIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    ip_address: resp.list[i].ip_address,
                    fingerprint: resp.list[i].fingerprint,
                    useragent: resp.list[i].useragent,
                    auth_kind: resp.list[i].auth_kind
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerAuthLogListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet.exec({
            user_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    ip_address: resp.list[i].ip_address,
                    fingerprint: resp.list[i].fingerprint,
                    useragent: resp.list[i].useragent,
                    auth_kind: resp.list[i].auth_kind
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerAuthLogListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerAuthLogListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteUsrPlayerAuthLog.exec({
                data: {
                    usr_player_auth_log_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerAuthLogListCtl;
}(BaseController_1.BaseController));
exports.PlayerAuthLogListCtl = PlayerAuthLogListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerAuthLogsListCtl.ts
// module id = 937
// module chunks = 0